import _ from 'underscore';

export const getSubMenuConfig = (permissions) => {
  const subMenuConfig = {
    MenuSales: ['Purchase', 'AddToCart', 'BeginCheckout', 'Subcribe'],
    MenuLeads: ['SubmitLeadForm', 'BookAppointment', 'Signup', 'RequestQuote', 'GetDirections', 'OutboundClick'],
    MenuFurther: ['Contact', 'PageView', 'Download', 'Other'],
  };

  if (permissions.IsInStoreVisitGoalEnabled) {
    subMenuConfig.MenuFurther.splice(3, 0, 'InStoreVisit');
  }

  return subMenuConfig;
};

const getGoalTypesForCategory = (goalCategory) => {
  const defaultGoalTypes = ['DestinationGoal', 'EventGoal', 'OfflineConversionGoal'];
  switch (goalCategory) {
    case 'Purchase':
      return [...defaultGoalTypes, 'InStoreTransactionGoal', 'ProductConversionGoal'];
    case 'Download':
      return ['ApplicationInstallGoal'];
    case 'InStoreVisit':
      return ['InStoreVisitGoal', 'OfflineConversionGoal'];
    case 'Other':
      return [...defaultGoalTypes, 'DurationGoal', 'PageViewsPerVisitGoal'];
    default:
      return defaultGoalTypes;
  }
};

const objective2typeMap = {
  website: ['DestinationGoal', 'DurationGoal', 'EventGoal', 'PageViewsPerVisitGoal', 'ProductConversionGoal'],
  appInstall: ['ApplicationInstallGoal'],
  import: ['InStoreTransactionGoal', 'OfflineConversionGoal', 'InStoreVisitGoal'],
  phoneCall: [],
};

export const getAvailableGoalTypes = (goalObjective, goalCategory, permissions) => {
  const typesForObjective = objective2typeMap[goalObjective];
  const typesForCategory = getGoalTypesForCategory(goalCategory);
  const availableTypes = [];

  typesForCategory.forEach(x => typesForObjective.includes(x) && availableTypes.push(x));

  // filter out unsupported goal type (product conversion, instore transaction)
  const isProductConversionGoalEnabled = permissions && permissions.IsProductConversionsSupported
  && (permissions.IsEnhancedShoppingCampaignAllowed || permissions.IsAIMCampaignEnabled || permissions.IsAIMUKEnabled);
  const isIntoreTransactionEnabled = permissions && permissions.IsInStoreTransactionAttributionSupported;

  const filteredTypes = availableTypes.filter(x => !((x === 'ProductConversionGoal' && !isProductConversionGoalEnabled) || (x === 'InStoreTransactionGoal' && !isIntoreTransactionEnabled)));
  return filteredTypes;
};

export const getObjectiveByGoalType = (goalType) => {
  let objective = null;
  _.each(Object.keys(objective2typeMap), (objectiveKey) => {
    if (objective2typeMap[objectiveKey].includes(goalType)) {
      objective = objectiveKey;
    }
  });
  return objective;
};
